"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
_export_star(require("./task-query"), exports);
_export_star(require("./task-console"), exports);
_export_star(require("./task-review-cycle"), exports);
_export_star(require("./task-survey"), exports);
function _export_star(from, to) {
    Object.keys(from).forEach(function(k) {
        if (k !== "default" && !Object.prototype.hasOwnProperty.call(to, k)) {
            Object.defineProperty(to, k, {
                enumerable: true,
                get: function() {
                    return from[k];
                }
            });
        }
    });
    return from;
}
